import React from "react";
import Header from "../../layouts/header";
import golf from "../../assets/images/2025-Program/golf-ball-flag.jpg";
import { useTranslation } from "react-i18next";

export default function Trips() {
  const { t } = useTranslation();

  return (
    <div>
      <Header image={golf} title="Trips" />
      <div className="flex justify-center items-center">
        <div className="h-full flex flex-col justify-start items-center gap-4 md:gap-4 w-full md:w-[75%] px-8 mb-20">
          <div className="flex flex-col gap-4 md:gap-8 w-full">
            <div className="w-full">
              <div className="flex justify-center items-center mb-4"></div>
              <div className="space-y-8">
                {/* Blank section for future content */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

